import React, { useContext, useEffect } from "react";
import { Auth } from "./authProvider";
import useCustomIdleTimer from "../hooks/system/useCustomIdleTimer";
import { useLocation } from "react-router-dom";


export function IdleTimerGate() {
    const auth = useContext(Auth);
    const location = useLocation();

    const { reset } = useCustomIdleTimer({
        enabled: (auth.isAuthenticated()),
    });

    useEffect(() => {
        reset();
    }, [location.pathname, location.search, location.hash, reset]);

    return null;
}
